import Reveal from "./Reveal";

export default function FinalCTA() {
  return (
    <section className="py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <Reveal>
          <div className="relative overflow-hidden rounded-lg bg-gradient-to-br from-foreground-900 via-primary-900 to-primary-700 px-6 md:px-16 py-14 md:py-20 text-center">
            <div className="absolute inset-0 opacity-20 pointer-events-none">
              <div className="absolute top-0 right-10 w-64 h-64 rounded-full bg-accent-400/40 blur-3xl" />
              <div className="absolute bottom-0 left-10 w-64 h-64 rounded-full bg-primary-400/40 blur-3xl" />
            </div>

            <div className="relative z-10 max-w-2xl mx-auto">
              <h2 className="font-heading font-extrabold text-white text-3xl md:text-4xl tracking-tight">
                Ready for a Better IT Experience?
              </h2>
              <p className="mt-4 text-white/75 text-base md:text-lg leading-relaxed">
                Let's talk about your technology, your challenges, and where you want your business
                to go next.
              </p>
              <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
                <a
                  href="#contact"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-white text-primary-700 px-7 py-3.5 text-sm font-semibold hover:bg-background-100 transition-colors duration-200 cursor-pointer"
                >
                  Get a Free Consultation
                  <i className="ri-arrow-right-line" />
                </a>
                <a
                  href="tel:+18184696734"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-white/30 text-white px-7 py-3.5 text-sm font-semibold hover:bg-white/10 transition-colors duration-200 cursor-pointer"
                >
                  <i className="ri-phone-line" />
                  Call (818) 469-6734
                </a>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}